import { Role, roleRouteConfig } from "../consts/roles";

export const canAccessRoute = (role: Role | undefined, route: string): boolean => {
    if (!role) return false;
    return roleRouteConfig[role]?.includes(route) ?? false;
};
